"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getNetworkUrl(_a) {
    var protocol = _a.protocol, host = _a.host, port = _a.port;
    return (protocol ? protocol : 'http') + "://" + host + (port ? ":" + port : '');
}
exports.getNetworkUrl = getNetworkUrl;
function getErrorMessage(error, fallbackMessage) {
    if (fallbackMessage === void 0) { fallbackMessage = 'Error'; }
    if (error) {
        return typeof error === 'string' ? error : error.message || fallbackMessage;
    }
    return fallbackMessage;
}
exports.getErrorMessage = getErrorMessage;
//# sourceMappingURL=util.js.map